import { render, staticRenderFns } from "./agv-breadcrumbs.vue?vue&type=template&id=5a970de8&scoped=true&lang=pug&"
import script from "./agv-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./agv-breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./agv-breadcrumbs.vue?vue&type=style&index=0&id=5a970de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a970de8",
  null
  
)

export default component.exports